import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';

import { styled } from '@mui/material/styles';
import { Grid, Box, Typography, Avatar } from '@mui/material';
import PropTypes from 'prop-types';

import Card from '../../../components/layout/atoms/Card';
import SmallButton from '../../../components/layout/atoms/SmallButton';
import InfoToolTip from '../../../components/layout/atoms/InfoToolTip';
import IconHeading from '../../../components/layout/molecules/IconHeading';
import Loading from '../../../components/layout/organisms/Loading/Loading';
import ConfirmPurchase from '../../exams/components/ConfirmExamModal';

import { setSnackbar, handleModalOpen, handleModalClose } from '../../../actions/controls';
import { submitServices, checkServiceInput } from '../../../actions/riskServices';
import { getPatientDetails, getPatientRiskServices } from '../../../actions/patients';

import { ActivityIcon, ArrowRightIcon, PlusIcon, UserCheckIcon } from '../../../resources/icons';
import maleAvatar from '../../../resources/icons/files/male-avatar.svg';
import femaleAvatar from '../../../resources/icons/files/female-avatar.svg';
import otherAvatar from '../../../resources/icons/files/other-avatar.svg';
import { DR_RISK, GENDER_FEMALE, GENDER_MALE, STDR_RISK } from '../../../constants/constants';
import StatusButton from '../../../components/layout/atoms/StatusButton';
import theme from '../../../styles/theme';

const StyledButtonGrid = styled(Grid)(({ theme }) => ({
  justifyContent: 'flex-start',
  [theme.breakpoints.up('lg')]: {
    justifyContent: 'flex-end',
  },
}));

const PatientHeader = (props) => {
  const staticWords = useSelector((state) => state.handlingTranslation.words);

  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [checkedServices, setCheckedServices] = React.useState(new Set());

  return (
    <>
      {/* CARD WITH WHITE BACKGROUND */}
      <Card size="fill" sx={{ padding: (theme) => theme.spacing(3) }}>
        {/* SECTION TITLE */}
        <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
          <Grid item container gap={3} alignItems="center" wrap="nowrap" xs={12} lg={6}>
            <Grid item>
              {/* Choose the avatar based on the gender */}
              <Avatar
                alt="avatar"
                src={
                  props.patientDetails.demographics.gender === GENDER_MALE
                    ? maleAvatar
                    : props.patientDetails.demographics.gender === GENDER_FEMALE
                      ? femaleAvatar
                      : otherAvatar
                }
              />
            </Grid>
            <Grid container item spacing={1} direction="row" alignItems="center">
              <Grid item>
                <Typography variant="h3">{props.patientDetails.user.user_contact.first_name}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="h3">{props.patientDetails.user.user_contact.last_name}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="h3">{`(${props.patientDetails.user.account_number})`}</Typography>
              </Grid>
              {/* Show the patient external status */}
              {props.patientDetails?.external && (
                <Grid item mx={theme.spacing(1)}>
                  <StatusButton
                    status={'external'}
                    btnStyles={{
                      ...theme.typography.h4,
                      width: 90,
                      height: 28,
                      textTransform: 'capitalize',
                      fontFamily: theme.typography.fontFamily,
                      borderRadius: 40,
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

PatientHeader.propTypes = {
  patients: PropTypes.array,
};
// MAP REDUX STATE TO COMPONENT PROPS
// To retrieve patients from props, use -> props.patients
const mapStateToProps = (state) => ({
  patientDetails: state.patients.patientDetails,
  servicePrices: state.payments.servicePrices,
  disableDR: state.controls.disableDR,
  messageDR: state.controls.messageDR,
  disableSTDR: state.controls.disableSTDR,
  messageSTDR: state.controls.messageSTDR,
});

export default connect(mapStateToProps, {
  setSnackbar,
  handleModalOpen,
  handleModalClose,
})(PatientHeader);
